module.exports = __webpack_public_path__ + "static/media/easterneurope.4061f6d0.png";